"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Geocoder für Nominatim (OSM-Webservice).
 *
 * @class
 * @extends gc.gis.widget.GCLocator.AbstractGeocoder
 * @memberof gc.gis.module.GCLocator
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen. Siehe {@link gc.gis.module.GCLocator.AbstractGeocoder}
 */
gc.gis.module.GCLocator.NominatimGeocoder = function( options )
{
	options.id = '__nominatim__';
	options.outputFormat = gc.gis.format.GEOJSON;

	gc.gis.module.GCLocator.AbstractGeocoder.call( this, options );

	// Nominatim setzt Header: Access-Control-Allow-Origin "*"
	this.url_nominatim = 'https://nominatim.openstreetmap.org/search';
	this.params_nominatim = {
		format: 'json',
		countrycodes: 'de',
		bounded: '1',
		polygon_geojson: '1',
		'accept-language': 'de'
		//'json_callback': ''       // nicht erforderlich: Access-Control-Allow-Origin "*"
	};
};
gc.gis.module.GCLocator.NominatimGeocoder.prototype = Object.create( gc.gis.module.GCLocator.AbstractGeocoder.prototype );

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.NominatimGeocoder.prototype._getQueryString = function(self, control_index, opt_detail_search)
{
	// opt_detail_search hat hier keine Relevanz (aber z.B. bei internen Suchdiensten)
	for(let i = 0; i <= control_index; i++)
	{
		let input = this.controls[i]._element_input;
		this.params_nominatim[input.attr('name')] = input.val();
	}

	return gc.gis.GCUrl.buildUrl(this.url_nominatim, this.params_nominatim);
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.NominatimGeocoder.prototype._validateControl = function( element_input, cur_control_index, max_control_index )
{
	if( element_input )
	{
		if( element_input.val().length === 0 )
		{
			throw new Error('Kein Suchbegriff eingegeben.');
		}
		if( element_input.val().length < this.autocomplete_length )
		{
			throw new Error('Der Suchbegriff ist zu kurz. Geben Sie min. ' + this.autocomplete_length + ' Zeichen ein.');
		}
	}
	else
	{
		throw new Error('Internal error: no control given');
	}
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.NominatimGeocoder.prototype._parseGeocoderResults = function( data )
{
	// Ergebnisse klassifizieren
	const categories = {};

	for(let i = 0; i < data.length; i++)
	{
		const clazz = data[i]['class'];
		const type  = data[i].type;

		const key = clazz + '-' + type;
		if(!categories[key])
		{
			categories[key] = [];
		}
		categories[key].push(data[i]);
	}

	return categories;
};

/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.NominatimGeocoder.prototype._renderResultList = function(self, control, items, opt_show_list)
{
	// Alte Ergebnisse entfernen
	const list = control._element_list;
	list.children().remove();

	// Ausgabe
	const keys = Object.keys( items );
	for (let i = 0; i < keys.length; i++ )
	{
		const li_cat = jQuery('<li>', {
			'class': 'dropdown-header'
		});
		li_cat.append( jQuery('<strong> ', {
			text: self.__lookupKey( keys[i] ) +' ('+ items[keys[i]].length +')'
		}) );
		list.append( li_cat );

		for (let j = 0; j < items[keys[i]].length; j++ )
		{
			let li = self.__renderResultItem( self, items[keys[i]][j] );
			list.append( li );
		}
	}

	// Keine Ergebnisse
	if (items.length === 0)
	{
		list.append( jQuery('<li>', {
			'class': 'empty',
			text: 'Keine Ergebnisse'
		}) );
	}
	// Ggf. Liste anzeigen
	if (opt_show_list)
	{
		list.show('fade');
	}
};

/**
 * @private
 * @method
 *
 * @param {gc.gis.module.GCLocator.Geocoder} self this
 * @param {Object} data Suchergebnis
 */
gc.gis.module.GCLocator.NominatimGeocoder.prototype.__renderResultItem = function( self, data )
{
	const label = data.display_name;
	const btn_label = jQuery('<a>', {
		href: '#',
		html: '<span>'+ label +'</span>',
		click: function( evt ) {
			evt.preventDefault();
			try
			{
				self._showOnMap(data);
			}
			catch( err )
			{
				gc.gis.iface.log.error( self, err )
			}
			jQuery(this).blur();
			return false;
		}
	});

	const li = jQuery('<li>', {
		'class': 'geocoder-item'
	});
	li.append( btn_label );

	return li;
};


/**
 * @inheritdoc
 */
gc.gis.module.GCLocator.NominatimGeocoder.prototype._showOnMap = function (result_item)
{
	const label = result_item.display_name;
	const bbox = [
		parseFloat(result_item.boundingbox[2]),	// xmin
		parseFloat(result_item.boundingbox[0]),	// ymin
		parseFloat(result_item.boundingbox[3]),	// xmax
		parseFloat(result_item.boundingbox[1])	// ymax
	];
	const geom = result_item.geojson;
	const lon = parseFloat(result_item.lon);
	const lat = parseFloat(result_item.lat);

	try
	{
		this.map.highlightGeometryWithMarker(geom, gc.gis.format.GEOJSON, label, {
			projection: 'EPSG:4326',
			markerPosition: [lon, lat],
			markerProjection: 'EPSG:4326',
			style: gc.gis.iface.styleFactory.getStyle(gc.gis.factory.StyleType.GEOCODE),
			styleActive:  gc.gis.iface.styleFactory.getStyle(gc.gis.factory.StyleType.GEOCODE_ACTIVE)
		});

		this.map.fitExtent(bbox, {
			projection: 'EPSG:4326',
			constrain_resolution: true,
			minscale: Math.min(gc.gis.iface.ZOOM_TO_MINSCALE, this.map.getScale())
		});
	}
	catch (err)
	{
		if (err instanceof gc.gis.error.GCOutOfMaxExtentError)
		{
			gc.gis.iface.log.info(this, err.message);
		}
		else
		{
			gc.gis.iface.log.error(this, err.message);
		}
	}
};

/**
 * Übersetzt zusammengesetzte Nominatim-Schlüssel in menschenlesbares.
 *
 * @private
 * @method
 *
 * @param {string} key
 * @returns {string}
 */
gc.gis.module.GCLocator.NominatimGeocoder.prototype.__lookupKey = function( key )
{
	// http://wiki.openstreetmap.org/wiki/DE:Map_Features
	const dict = {
		'boundary-administrative': 'Verwaltungsgrenze',

		'place-country': 'Staat',
		'place-state': 'Bundesland',
		'place-region': 'Region',
		'place-county': 'Verwaltungsbezirk',

		'place-city': 'Hauptstadt/Großstadt',
		'place-suburb': 'Stadtteil',
		'place-neighbourhood': 'Viertel/Nachbarschaft',
		'place-town': 'Stadt/Kleinstadt',
		'place-village': 'Dorf',
		'place-hamlet': 'Weiler',
		'place-isolated_dwelling': 'Kleinstsiedlung',
		'place-farm': 'Bauernhof',
		'place-house': 'Hausnummer',

		'building-yes': 'Gebäude',

		'amenity-bar': 'Area Bar, Nachtlokal',
		'amenity-bbq': 'Grillplatz',
		'amenity-biergarten': 'Biergarten',
		'amenity-cafe': 'Café',
		'amenity-fast_food': 'Schnell-Restaurant, Imbiss',
		'amenity-food_court': 'Restaurants und Imbisse',
		'amenity-ice_cream': 'Eisdiele',
		'amenity-pub': 'Kneipe',
		'amenity-restaurant': 'Restaurant',

		'amenity-college': 'Hochschule',
		'amenity-kindergarten': 'Kindergarten',
		'amenity-library': 'Bibliothek, Bücherei',
		'amenity-school': 'Schule',
		'amenity-music_school': 'Musikschule',
		'amenity-driving_school': 'Fahrschule',
		'amenity-language_school': 'Sprachschule',
		'amenity-university': 'Universität',

		'amenity-bus_station': 'Busbahnhof',
		'amenity-fuel': 'Tankstelle',
		'amenity-parking': 'Parkplatz',
		'amenity-parking_space': 'Stellplatz',
		'amenity-taxi': 'Taxistand',

		'highway-motorway': 'Autobahn',
		'highway-trunk': 'Autobahnähnliche Straße',
		'highway-primary': 'Bundesstraße',
		'highway-secondary': 'Landes-/Kreisstraße',      // Landes-, (Staats-,) oder sehr gut ausgebaute Kreisstraße
		'highway-tertiary': 'Kreis-/Gemeindestraße',
		'highway-residential': 'Straße',
		'highway-service': 'Weg',
		'highway-motorway_junction': 'Autobahnanschluss',

		'highway-bus_stop': 'Bushaltestelle',
		'highway-services': 'Raststätte',

		'railway-halt': 'Bahn-Haltepunkt',
		'railway-platform': 'Bahnsteig',
		'railway-station': 'Bahnhof',
		'railway-subway_entrance': 'U-Bahn Eingang',
		'railway-tram_stop': 'Straßenbahnhaltestelle',
		'railway-crossing': 'Bahnübergang',
		'railway-level_crossing': 'Bahnübergang',


		'place-postcode': 'Postleitzahlbereich',

		'tourism-museum': 'Museum',
		'tourism-gallery': 'Kunstgalerie',

		'leisure-stadium': 'Stadion',
		'leisure-pitch': 'Sportplatz',
		'leisure-sports_hall': 'Sporthalle',
		'leisure-sports_centre': 'Sportzentrum',
		'leisure-fitness_centre': 'Fitnessstudio',
		'leisure-bowling_alley': 'Bowling-/Kegelbahn',
		'leisure-water_park': 'Wasserpark'
	};
	if( dict[key] )
	{
		return dict[key];
	}
	return key;
};
